<template>
    <div class="content" id="pillars">
         <!-- 
        - #SERVICE
      -->

      <section class="section service">
        <div class="container">
          <h2 class="h2 section-title underline">OUR PILLARS</h2>
          
          <ul class="service-list">
            <li>
              <div class="service-card">
                <a href="/estratege">
                <div class="imgem-work">
                 <img src="/img/tres.png" alt="">
                </div>
                </a>
                <h3 class="h3 title">Strategy</h3>

                <p class="text">
Direcção clara, foco e vantagem competitiva.


                </p>
                <!--
                <button class="card-btn" aria-label="Show More">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </button>
              -->
              </div>
            </li>

            <li>
              <div class="service-card">
                <a href="/people">
              <div class="imgem-work">
                 <img src="/img/seis.png" alt="">
                </div>
              </a>
                <h3 class="h3 title">People</h3>

                <p class="text">
Equipas alinhadas, lideranças fortes e cultura
de performance.



                </p>

              </div>
            </li>

            <li>
                <div class="service-card">
                <a href="/revenue">
              <div class="imgem-workzero">
                 <img src="/img/zero.png" alt="">
                </div>
              </a>
                <h3 class="h3 title">Revenue</h3>

                <p class="text">
Modelos comerciais eficientes, crescimento e rentabilidade
                </p>

              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
</template>

<script>
import ScrollReveal from 'scrollreveal';
  export default{
      mounted() {
    ScrollReveal().reveal('section, .hero-title', {
      origin: 'top',
      distance: '50px',
      duration: 3000,
      delay: 70,
      reset: false,
      origin:'left'
    });
    ScrollReveal().reveal('figure, .element .copys', {
      origin: 'top',
      distance: '50px',
      duration: 4000,
      delay: 100,
      reset: false,
      origin:'right'
    });

    ScrollReveal().reveal('#about p, #about h3, h1, ' , {
      origin: 'bottom',
      distance: '30px',
      duration: 1000,
      delay: 100,
      interval: 200,
      reset: true
    });

    ScrollReveal().reveal('.icon, #services p', {
      origin: 'left',
      distance: '20px',
      duration: 800,
      delay: 100,
      reset: true
    });
  }
  }
</script>

<style scoped>

/*-----------------------------------*\
  #SERVICE
\*-----------------------------------*/
.content{
  background: radial-gradient(circle,rgba(246, 171, 124, 0.1) 100%, rgba(255, 255, 255, 0.11) 100%);

}
.service-list {
  display: grid;
  gap: 30px;
}

.service-card {
  padding: 30px;
/*  box-shadow: var(--shadow);*/
  border-radius: var(--radius-12);
}


.service-card h1{
  font-weight: bold;
  font-size: 12rem;
  text-align: center;
  color: var(--menu-color);
}

.service-card .card-icon {
  background-image: url("https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/service-banner-pattern.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-color: hsla(335, 87%, 53%, 0.12);
  aspect-ratio: 1 / 1;
  max-width: 165px;
  display: grid;
  place-content: center;
  margin-inline: auto;
  transition: var(--transition-1);
}

.service-card:hover .card-icon {
  background-color: var(--menu-color);
}

.service-card .card-icon ion-icon {
  font-size: 5rem;
  color: var(--menu-color);
  --ionicon-stroke-width: 20px;
  transition: var(--transition-1);
}

.service-card:hover .card-icon ion-icon {
  color: var(--white);
}

.service-card .title {
  text-align: center;
  margin-block-end: 15px;
}

.service-card .text {
  text-align: center;
  margin-block-end: 20px;
}

.service-card .card-btn {
  margin-inline: auto;
  padding: 15px;
  border: 1px solid var(--menu-color);
  border-radius: 50%;
  color: var(--winter-sky);
  transition: var(--transition-1);
}

.service-card .card-btn:is(:hover, :focus) {
  color: var(--white);
  background-color: var(--menu-color);
}

/* Big number*/
.imgem-work,.imgem-workzero {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2%;
}
.imgem-work img{
  width: 35%;
}
.imgem-workzero img{
   width: 47%;
}



</style>